import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { NestedPageHeader } from '../../components/header/page.header';
import { TenantMachines } from '../../components/tenant/tenant-machines';
import { useBeaconRouter } from '../../route/route.hooks';
import { useActiveWorkspace } from '../../store/workspace/workspace.hooks';

const TenantMachinesPage = (): ReactElement => {
  const { i18n } = useTranslation();
  const workspace = useActiveWorkspace();
  const { builder } = useBeaconRouter();

  let pageName: string = i18n.t('common:robots');
  if (workspace?.tenant.name) {
    pageName = `${workspace.tenant.name} ${i18n.t('common:robots')}`;
  }

  return (
    <IonPage>
      <NestedPageHeader
        title={pageName}
        defaultBackRoute={builder.getAdminRoute()}
      />
      <IonContent>
        <TenantMachines />
      </IonContent>
    </IonPage>
  );
};

export { TenantMachinesPage };
